import { Link } from "gatsby"
import React from "react"

import Umr from "./umr-link"

const Header: React.FC<{ siteTitle: String }> = ({ siteTitle }) => (
  <header className="bg-fb12-blue-400 text-white text-2xl">
    <div class="mx-auto pt-6 max-w-4xl md:max-w-6xl w-full px-4 flex flex-wrap-reverse justify-between">
      <div class="pb-4 mr-6 pt-1">
        <h3 className="">
          <a
            href="https://www.uni-marburg.de/de/fb12/"
            className="whitespace-no-wrap text-xl text-fb12-blue-200 hover:text-fb12-blue-100"
          >
            FB 12
          </a>
        </h3>
        <h1 class="m-0 text-4xl text-fb12-blue-100 hover:text-white">
          <Link to="/" class="">
            Didaktik der Informatik
          </Link>
        </h1>
      </div>
      <div class="pt-1">
        <h3>
          <Umr className="text-fb12-blue-100 hover:text-white fill-current" />
        </h3>
      </div>
    </div>
  </header>
)

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
